import React from 'react';

import { getActiveSavedCart, getSavedCartDiamonds } from '../Util/SavedCart';

const savedCartContext = React.createContext(initialSavedCartDetails());

function initialSavedCartDetails() {
  return {
    errorMessage: null,
    savedCart: null,
    cartItems: null,
    loading: false,
  };
}

async function fetchSavedCartDetails(userAccount) {
  try {
    const savedCart = await getActiveSavedCart();
    if(savedCart === null) {
      return initialSavedCartDetails();
    }
    const cartItems = {};
    const cartItemsResult = await getSavedCartDiamonds(savedCart.id);
    cartItemsResult.forEach(cartItem =>
      cartItems[cartItem.diamondId] = cartItem
    );
    return {
      errorMessage: null,
      savedCart: savedCart,
      cartItems: cartItems,
      loading: false,
    };
  } catch(error) {
    return {
      errorMessage: error.toString(),
      savedCart: null,
      cartItems: null,
      loading: false,
    };
  }
}

export { savedCartContext, initialSavedCartDetails, fetchSavedCartDetails };
